import { render, staticRenderFns } from "./component-dea9b99e.vue?vue&type=template&id=48bb8292&scoped=true&"
import script from "./component-dea9b99e.vue?vue&type=script&lang=js&"
export * from "./component-dea9b99e.vue?vue&type=script&lang=js&"
import style0 from "./component-dea9b99e.vue?vue&type=style&index=0&id=48bb8292&lang=scss&scoped=true&"
import style1 from "./component-dea9b99e.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb8292",
  null
  
)

export default component.exports